<template>
  <CardTitleContent
    title="Alertas de Estoque"
    :startOpen="true"
  >
    <template #header-controls>
      <span class="label label-danger">{{ alerts.length }} alerta{{ alerts.length > 1 ? 's' : ''}}</span>
    </template>

    <div
      class="alert alert-danger d-flex justify-content-between align-items-center"
      v-for="alert in alerts"
      :key="alert.id"
    >
      {{ alert.message }}
      <b-button
        size="sm"
        pill
        :variant="alert.suspendedUntil ? 'warning' : 'danger'"
        @click="suspend(alert.id)"
        :title="alert.suspendedUntil ? `Suspenso até ${getDate(alert.suspendedUntil)}` : 'Suspender envio de e-mail'"
      >
        <i class="fas fa-ban" />
      </b-button>
    </div>
  </CardTitleContent>
</template>

<script>
import moment from 'moment'
import CardTitleContent from '@/components/shared/CardTitleContent.vue'

export default {
  name: 'StockAlerts',

  components: {
    CardTitleContent,
  },

  props: {
    alerts: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  methods: {
    /**
     * Emits an event to the parent component to handle the suspension.
     * @param {number} alertId - The ID of the alert to suspend.
     */
    suspend(alertId) {
      this.$emit('suspend', alertId)
    },

    /**
     * Formats a date string.
     * @param {string} date - The date to format.
     * @returns {string} The formatted date.
     */
    getDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  }
}
</script>
